(() => {
  if (window.PinPaintLaunchPriceInitialized) return;

  window.PinPaintLaunchPriceInitialized = true;

  const DAY = 24 * 60 * 60 * 1000;

  function updateLaunchPrice(priceElement) {
    if (!priceElement) return;

    const enabled = priceElement.dataset.launchEnabled === 'true';

    if (!enabled) return;

    const endTimestamp = Number(priceElement.dataset.launchEnd) * 1000;

    if (!endTimestamp || Number.isNaN(endTimestamp)) {
      deactivateLaunchPrice(priceElement);
      return;
    }

    const remaining = endTimestamp - Date.now();

    if (remaining <= 0) {
      deactivateLaunchPrice(priceElement);
      return;
    }

    activateLaunchPrice(priceElement, remaining);
  }

  function activateLaunchPrice(priceElement, remaining) {
    priceElement.classList.add('price--launch-active');

    const badge = priceElement.querySelector('[data-launch-badge]');
    if (!badge) return;

    /*
     * 最后 24 小时
     */
    if (remaining <= DAY) {
      badge.textContent = 'Final 24 Hours';
      return;
    }

    /*
     * 超过 24 小时
     */
    const daysLeft =Math.ceil(remaining / DAY);
    badge.textContent = `${daysLeft} Days Left`;
  }

  function deactivateLaunchPrice(priceElement) {
    priceElement.classList.remove('price--launch-active');

    const badge = priceElement.querySelector('[data-launch-badge]');
    if (!badge) return;

    const defaultLabel = badge.dataset.defaultLabel;
    if (defaultLabel) {
      badge.textContent = defaultLabel;
    }
  }

  function updateAllLaunchPrices() {
    document.querySelectorAll('[data-launch-enabled="true"]').forEach(updateLaunchPrice);
  }

  /*
   * 页面加载后立即运行
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',updateAllLaunchPrices);
  } else {
    updateAllLaunchPrices();
  }

  /*
   * 每秒检查一次
   */
  setInterval(updateAllLaunchPrices,1000);

  /*
   * Shopify Theme Editor
   */
  document.addEventListener('shopify:section:load',updateAllLaunchPrices);

})();